import * as React from "react";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {
    ISortElementsPayload, sortElementsOnShelf
} from "src/store/actions";
import {TActions} from "src/store/models";

interface IProps {
    shelfId: string;
}
type TProps = IDispatchToProps & IProps;

class SortFruitsOnShelf extends React.Component<TProps, {}> {

    public handleSort = () => {
        const {shelfId} = this.props;
        this.props.sortElements({shelfId})
    };

    public render() {
        return (
            <div className="SortFruitsOnShelf" onClick={this.handleSort}>
                <span>sort</span>
            </div>
        );
    }
}

interface IDispatchToProps {
    sortElements: (payload: ISortElementsPayload) => void;
}

export const mapDispatchToProps = (dispatch: Dispatch<TActions>): IDispatchToProps => ({
    sortElements: (payload: ISortElementsPayload) => dispatch(sortElementsOnShelf(payload))
});

const connected = connect(null, mapDispatchToProps)(SortFruitsOnShelf);
export {connected as SortFruitsOnShelf};


// WEBPACK FOOTER //
// ./src/containers/view/SortFruitsOnShelf.tsx